import Fuse from 'fuse.js';
import { slugify } from './tocExtractor';

export interface SearchSection {
  anchor: string;
  title: string;
  body: string;
}

export interface SearchResult {
  anchor: string;
  title: string;
  excerpt: string;
}

export function buildSearchIndex(sections: SearchSection[]): Fuse<SearchSection> {
  return new Fuse(sections, {
    keys: ['title', 'body'],
    threshold: 0.4,
    includeMatches: true,
    minMatchCharLength: 3,
    ignoreLocation: true,
  });
}

export function search(index: Fuse<SearchSection>, query: string): SearchResult[] {
  if (!query || query.trim().length < 2) return [];
  const results = index.search(query, { limit: 10 });
  return results.map(({ item }) => ({
    anchor: item.anchor,
    title: item.title,
    excerpt: item.body.slice(0, 160) + (item.body.length > 160 ? '…' : ''),
  }));
}

export function extractSections(markdown: string): SearchSection[] {
  const sections: SearchSection[] = [];
  const lines = markdown.split('\n');
  let current: SearchSection | null = null;

  for (const line of lines) {
    const m = /^(#{2,3})\s+(.+?)(?:\s+\{#([^}]+)\})?$/.exec(line);
    if (m && m[2]) {
      if (current) sections.push(current);
      const text = m[2].trim();
      const anchor = m[3]?.trim() || slugify(text);
      current = { anchor, title: text, body: '' };
    } else if (current) {
      current.body += line + '\n';
    }
  }
  if (current) sections.push(current);
  return sections;
}
